

export class CookieConcentHandler {

    static readUserConcent() {
        if('CookieScript' in window) {
            return CookieScript.instance.currentState();
        };

        return { action: 'unavailable', categories: [] };
    }

	static show() {
        if('CookieScript' in window) {
            return CookieScript.instance.show();
        };

        return;
    }

	static check({ acceptance = '', categories = [] }) {
		const { 
			action: userAction = '', 
			categories: userAllowedCategories = [] 
		} = this.readUserConcent();
		const { length } = categories;
		let index = 0;

		if(acceptance === '' && !length) {
			return true
		};

		if(userAction === 'unavailable') {
			return true;
		};

		for (index; index < length; index++) {

			if(userAllowedCategories.indexOf(categories[index]) <= -1) {
				return false;
			};
		};

		return userAction === acceptance;
	}
};